import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import type { TestOutcome } from "@/types/ab-tests";

interface ActionSectionProps {
  outcome: TestOutcome | "";
  switchDate: string;
  onOutcomeChange: (v: TestOutcome) => void;
  onSwitchDateChange: (v: string) => void;
}

export function ActionSection({ outcome, switchDate, onOutcomeChange, onSwitchDateChange }: ActionSectionProps) {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label className="text-xs uppercase tracking-wider text-muted-foreground font-medium">Outcome</Label>
        <RadioGroup value={outcome || ""} onValueChange={(v) => onOutcomeChange(v as TestOutcome)} className="space-y-2">
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="control" id="outcome-control" />
            <Label htmlFor="outcome-control" className="text-sm font-normal cursor-pointer">Keep Variant A — no listing change</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="variant" id="outcome-variant" />
            <Label htmlFor="outcome-variant" className="text-sm font-normal cursor-pointer">Apply Variant B to live listing</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="inconclusive" id="outcome-inconclusive" />
            <Label htmlFor="outcome-inconclusive" className="text-sm font-normal cursor-pointer">Inconclusive — no action</Label>
          </div>
        </RadioGroup>
      </div>
      {outcome === "variant" && (
        <div className="space-y-1.5">
          <Label htmlFor="switch-date" className="text-xs uppercase tracking-wider text-muted-foreground font-medium">Variant B switch date</Label>
          <Input id="switch-date" type="date" value={switchDate} onChange={(e) => onSwitchDateChange(e.target.value)} />
        </div>
      )}
    </div>
  );
}
